/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { DirtyType } from '@gh/common-shared-data';
import { arrayOf, date, DateFormat, entity, enumeration, subentity } from '@gh/core-data';
import { CommunicationListItemDto, CommunicationListItemMapper } from '../communications';
import { ContactCustomerType } from '../contacts';
import { UserDetailsShortDto } from '../users';
import {
  LeadDetailsInitDto,
  LeadDetailsSaveDto,
  LeadListItemDto,
  LeadSalesFolderSaveDto,
  LeadsListFilterDto,
} from './lead.dto';
import { SalesFolderStatus } from './sales-folder.dto';
import { SalesFolderShortMapper } from './sales-folder.mapper';

export const LeadDetailsInitMapper = entity<LeadDetailsInitDto>({
  typeOfCustomer: enumeration(ContactCustomerType),
  salesFolders: arrayOf(SalesFolderShortMapper),
  communications: arrayOf(CommunicationListItemMapper),
});
export const LeadDetailsSaveResponseMapper = LeadDetailsInitMapper;

export const LeadDetailsSaveMapper = entity<LeadDetailsSaveDto>({
  dirtyType: enumeration(DirtyType),
  typeOfCustomer: enumeration(ContactCustomerType),
  salesFolder: subentity<LeadSalesFolderSaveDto>({
    followUp: date(DateFormat.Date),
    status: enumeration(SalesFolderStatus),
    dirtyType: enumeration(DirtyType),
    createdLocal: date(DateFormat.DateTime),
  }),
});

export const LeadSalesPersonsMapper = entity<UserDetailsShortDto>();

export const LeadsDcMapper = entity<CommunicationListItemDto>({
  created: date(DateFormat.DateTime),
});

export const LeadListFilterMapper = entity<LeadsListFilterDto>();

export const LeadListItemMapper = entity<LeadListItemDto>(
  {
    lastContactDate: date(DateFormat.DateTime),
    createdDate: date(DateFormat.DateTime),
    nextActivity: date(DateFormat.DateTime),
});
